import OrdersService from './ordersService';
import TixLogger from './tixEventLogger';
import TixService from './tixService';
import WapiService, {
    initService,
    getCarrierInfo,
    getInterlinkC2CData,
    getInterlinkHomepageData,
    getSupportedCurrencies,
} from './wapiService';

export {
    OrdersService,
    TixLogger,
    TixService,
    WapiService,
    getCarrierInfo,
    getInterlinkC2CData,
    getInterlinkHomepageData,
    getSupportedCurrencies,
    initService,
};

export default WapiService;
